import { createContext, Dispatch, SetStateAction } from 'react';

export type GetPagePath = (page: string) => string;

export interface Route {
  path: string;
  routes: Route[];
}

export interface State {
  name: string;
  pages: string[];
}

export interface ConfigProviderValue extends GatsbyTypes.SitePageContextConfigJson {
  page: GatsbyTypes.SitePageContext['name'];
  previousPage?: string;
  getPagePath: GetPagePath;
  setGetPagePath: Dispatch<SetStateAction<GetPagePath>>;
  getMatchingPath: (initialRoutes: Route) => (path: string) => string;
}

export default createContext<ConfigProviderValue>({} as ConfigProviderValue);
